// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:55:15

export default {
  "id": "astrobot-dash",
  "slug": "astrobot-dash",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/202557c3e71e430d8c81881208900488-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/202557c3e71e430d8c81881208900488/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Astrobot Dash",
      "description": "Astrobot Dash is a game where you run along walls instead of on the ground. You will climb vertical surfaces, avoiding obstacles and head-on collisions. As you advance, try to complete the challenging levels, this game will test how fast you react.",
      "instructions": "touch or mouse right to move up/down",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1player",
        "arcade",
        "platformer",
        "runner",
        "speedrun"
      ]
    },
    "zh-CN": {
      "title": "星际机器人冲刺",
      "description": "宇航机器人冲刺是一款你沿着墙壁而非地面奔跑的游戏。你需要攀爬垂直表面，避开障碍物和正面碰撞。随着你前进，尝试完成具有挑战性的关卡，这款游戏将测试你的反应速度。",
      "instructions": "点击或鼠标右键向上/向下移动",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "街机",
        "平台游戏",
        "跑酷",
        "速度跑"
      ]
    },
    "zh-TW": {
      "title": "機械人竄躍大作戰",
      "description": "太空人冲刺是一款你在牆壁上跑而不是在地面上的遊戲。你將攀爬垂直表面，避開障礙物和迎面衝撞。隨著你進步，嘗試完成挑戰性等級，這款遊戲將測試你的反應速度。",
      "instructions": "點擊或滑鼠右鍵上/下移動",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "街機",
        "平台遊戲",
        "跑酷",
        "速跑"
      ]
    },
    "zh-HK": {
      "title": "機械人衝刺",
      "description": "星戰機疾馳是一款你沿著牆面而非地面奔跑的遊戲。你將會攀爬垂直表面，避開障礙物和迎面來的碰撞。隨著你進行，嘗試完成挑戰性的關卡，這款遊戲將測試你的反應速度有多快。",
      "instructions": "按 touch 或滑鼠右鍵上/下移動",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1人遊戲",
        "街機",
        "平台遊戲",
        "跑酷",
        "速度挑戰"
      ]
    },
    "ja": {
      "title": "アストロボットダッシュ",
      "description": "アストロボットダッシュは、地面ではなく壁を駆け上がるゲームです。垂直な表面を登りながら、障害物や正面からの衝突を避けましょう。進むにつれて、挑戦的なレベルをクリアしようとすると、このゲームはあなたの反応速度を試すことになります。",
      "instructions": "上/下に移動するには、タッチまたはマウス右ボタンを押してください。",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "アーケード",
        "プラットフォーム",
        "ランナー",
        "スピードラン"
      ]
    },
    "ko": {
      "title": "아스트로봇 다ッシュ",
      "description": "아스트로봇 다ッシュ는 지면 대신 벽을 달리는 게임입니다. 직립면을 오르며 장애물과 직진 충돌을 피하세요. 진행함에 따라 도전적인 레벨을 완료해 보세요. 이 게임은 반응 속도를 테스트할 것입니다.",
      "instructions": "触摸 또는 마우스 오른쪽 버튼으로 상/하 이동",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "아케이드",
        "플랫폼 게임",
        "러너",
        "스피드런"
      ]
    },
    "fr": {
      "title": "Astrobot Dash",
      "description": "Astrobot Dash est un jeu où vous courez le long des murs au lieu de la terre. Vous escaladerez des surfaces verticales, évitant les obstacles et les collisions frontales. À mesure que vous progresserez, essayez de terminer les niveaux délicats, ce jeu mettra à l'épreuve votre rapidité de réaction.",
      "instructions": "Toucher ou cliquer avec la souris à droite pour monter/descendre",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1 joueur",
        "arcade",
        "plate-forme",
        "runner",
        "course rapide"
      ]
    }
  }
};
